export const CALENDAR_TYPES = [
  { id: 'suelo', name: 'Siembra directa en suelo', color: '#FFFFFF' },
  { id: 'semillero', name: 'Siembra en semillero', color: '#FF9800' },
  { id: 'trasplante', name: 'Trasplante de semillero a suelo', color: '#795548' },
  { id: 'recolecta', name: 'Recolecta', color: '#4CAF50' }
];

export const MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export default function CalendarView({ seeds, onBack }) {
  return (
    <div className="huerto-container animate-fade" style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Calendario de Siembra</h2>
      </div>

      {/* Legend */}
      <div className="calendar-legend" style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '16px', padding: '12px', backgroundColor: 'var(--surface-color)', borderRadius: 'var(--radius-md)' }}>
        {CALENDAR_TYPES.map(type => (
          <div key={type.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
            <span style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: type.color, display: 'inline-block' }}></span>
            {type.name}
          </div>
        ))}
      </div>

      <div className="calendar-table-container" style={{ overflow: 'auto', maxHeight: '65vh', backgroundColor: 'var(--surface-color)', borderRadius: 'var(--radius-md)' }}>
        <table className="calendar-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
          <thead>
            <tr>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #444', position: 'sticky', top: 0, left: 0, backgroundColor: 'var(--surface-color)', zIndex: 30 }}>Semilla</th>
              {MONTHS.map(month => (
                <th key={month} style={{ padding: '12px 4px', textAlign: 'center', borderBottom: '2px solid #444', fontSize: '12px', position: 'sticky', top: 0, backgroundColor: 'var(--surface-color)', zIndex: 20 }}>{month}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {seeds.map((seed, i) => (
              <tr key={seed.id} style={{ backgroundColor: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent', borderBottom: '1px solid #333' }}>
                <td style={{ padding: '8px 12px', position: 'sticky', left: 0, backgroundColor: 'var(--surface-color)', zIndex: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{seed.icon}</span>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{seed.name}</span>
                  </div>
                </td>
                {MONTHS.map((_, monthIndex) => {
                  const typesForMonth = seed.calendar ? seed.calendar[monthIndex] || [] : [];
                  return (
                    <td key={monthIndex} style={{ padding: '8px 4px', textAlign: 'center', verticalAlign: 'middle' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '2px', width: '28px', margin: '0 auto' }}>
                        {typesForMonth.map(typeId => {
                          const typeDef = CALENDAR_TYPES.find(t => t.id === typeId);
                          if (!typeDef) return null;
                          return (
                            <span 
                              key={typeId} 
                              title={typeDef.name}
                              style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: typeDef.color, display: 'inline-block' }}
                            ></span>
                          );
                        })}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
